export default () => {
  const mainNavigation = document.querySelector('.js-main-navigation');
  const desktopPanels = document.querySelectorAll('.js-desktop-panel');
  const desktopPanelsClose = document.querySelectorAll(
    '.js-desktop-panel-close'
  );
  const parentLinks = mainNavigation.querySelectorAll('li');
  const navigationTabber = document.querySelectorAll('.js-tabber');

  const allHtml = document.querySelector('html');

  const closeAllPanels = () => {
    document.body.classList.remove('is-menu-open');
    removeClassFromList(desktopPanels, 'is-active');
    removeClassFromList(parentLinks, 'is-active');
    allHtml.style.overflow = 'auto';
  };

  if (mainNavigation) {
    // select all li that have data-panel-id attribute
    if (parentLinks) {
      parentLinks.forEach((item) => {
        item.addEventListener('click', (e) => {
          if (item.dataset.panelId) {
            e.preventDefault();

            // Check if the panel is already active
            if (item.classList.contains('is-active')) {
              // Close the panel if already active
              closeAllPanels();
            } else {
              // Open the panel
              document.body.classList.add('is-menu-open');
              allHtml.style.overflow = 'hidden';
              removeClassFromList(desktopPanels, 'is-active');
              removeClassFromList(parentLinks, 'is-active');
              item.classList.add('is-active');
              const panel = document.querySelector(
                `.js-desktop-panel[data-panel-id="${item.dataset.panelId}"]`
              );
              if (panel) {
                panel.classList.add('is-active');
              }
            }
          }
        });
      });
    }

    document.addEventListener('keyup', (e) => {
      if (
        (e.keyCode === 27 || e.key === 'Escape') &&
        document.body.classList.contains('is-menu-open')
      ) {
        closeAllPanels();
      }
    });

    // Close the open panel when clicking anywhere outside of it. Without this
    // the panel stays active after the user moves on, so the next click on its
    // tab closes it instead of opening it and the menu looks unresponsive.
    document.addEventListener('click', (e) => {
      // `is-menu-open` on the body is shared with the mobile hamburger menu,
      // so check the desktop panels themselves.
      if (!document.querySelector('.js-desktop-panel.is-active')) {
        return;
      }
      if (e.target.closest('.NavigationPanel') || e.target.closest('.js-main-navigation')) {
        return;
      }
      closeAllPanels();
    });

    if (navigationTabber) {
      navigationTabber.forEach((tabber) => {
        const tabs = tabber.querySelectorAll('.js-navigation-tab');
        tabs.forEach((tab) => {
          tab.addEventListener('click', (e) => {
            e.preventDefault();
            console.log('e.target', e.currentTarget);
            const tabKey = e.currentTarget.dataset.tab;
            const tabLink = e.currentTarget.querySelector('.Link');
            const tabContent = tabber.querySelector(
              `.js-navigation-tab-content[data-tab="${tabKey}"]`
            );
            const tabLinks = tabber.querySelectorAll(
              '.js-navigation-tab .Link'
            );
            const tabContents = tabber.querySelectorAll(
              '.js-navigation-tab-content'
            );

            removeClassFromList(tabLinks, 'is-active');
            removeClassFromList(tabContents, 'is-active');

            console.log('tabLink', tabLink);
            console.log('tabContent', tabContent);
            tabLink.classList.add('is-active');
            tabContent.classList.add('is-active');
          });
        });
      });
    }
  }

  if (desktopPanelsClose) {
    desktopPanelsClose.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        closeAllPanels();
      });
    });
  }
};

const removeClassFromList = (list, el_class) => {
  list.forEach((element) => {
    element.classList.remove(el_class);
  });
};
